import React, { useState } from 'react';
import { Link } from 'shared-routing';

import { injectTranslations, TranslationsFunc } from '@lang';
import Error from '@common/components/Error';
import Portal from '@common/components/Portal';
import { Routes } from '@common/constants';
import { ItineraryToggle } from '@common/components/BasketDrawer/BasketDrawer.styles';

import { BasketDetails } from 'shared-types/Basket';
import { Page } from 'shared-types/Common';
import ProductsListingForm from '../ProductsListingForm';
import Row from '../BasketRow';
import {
  BasketHeaderWrapper,
  ContinueShoppingButton,
  ContinueShoppingButtonWrapper,
  ItineraryToggleWrapper,
} from './Basket.styles';
import { getItineraryItems } from '@utils/getItineraryView';

type BasketProps = {
  basketDetails: BasketDetails;
  basketErrors: any;
  isBasketDetailsFetching: boolean;
  spaClassesPage: Page;
  tablesPage: Page;
  handleBasketRecalculate: () => void;
  handleSubmit: () => void;
  promoCodeFailure: boolean;
  tablesDisableChildBookings: boolean;
  t: TranslationsFunc;
  propertyId: number;
  language: string;
  isVouchersPaymentEnabled: boolean;
};

const Basket: React.FC<BasketProps> = ({
  basketDetails,
  basketErrors,
  handleBasketRecalculate,
  handleSubmit,
  isBasketDetailsFetching,
  tablesPage,
  promoCodeFailure,
  tablesDisableChildBookings,
  propertyId,
  language,
  t,
  isVouchersPaymentEnabled,
}) => {
  const [showItineraryView, setShowItineraryView] = useState(false);
  const itineraryItems = getItineraryItems(basketDetails.items);
  const hasItineraryItems = itineraryItems.some((item) => item.hasItems);

  return (
    <>
      <Portal selector="#breadcrumbs-title-item">
        <BasketHeaderWrapper>
          <h2>{t('basket.yourBasket')}</h2>
          <ContinueShoppingButtonWrapper>
            {basketDetails.items?.length ? (
              <Link route={Routes.HOME}>
                <ContinueShoppingButton>{t('basket.continueShopping')}</ContinueShoppingButton>
              </Link>
            ) : null}
          </ContinueShoppingButtonWrapper>
          {hasItineraryItems && (
            <ItineraryToggleWrapper marginTop="-20px" marginBottom="20px">
              <ItineraryToggle onClick={() => setShowItineraryView((val) => !val)}>
                {showItineraryView ? t('basket.itemisedView') : t('basket.itineraryView')}
              </ItineraryToggle>
            </ItineraryToggleWrapper>
          )}
        </BasketHeaderWrapper>
      </Portal>
      {basketErrors && (
        <Row>
          <Error error={basketErrors} />
        </Row>
      )}
      <Row align="left" alignMd="left">
        <ProductsListingForm
          showItineraryView={showItineraryView}
          handleBasketRecalculate={handleBasketRecalculate}
          basketDetails={basketDetails}
          isFetching={isBasketDetailsFetching}
          handleSubmit={handleSubmit}
          tablesPage={tablesPage}
          promoCodeFailure={promoCodeFailure}
          propertyId={propertyId}
          language={language}
          tablesDisableChildBookings={tablesDisableChildBookings}
          isVouchersPaymentEnabled={isVouchersPaymentEnabled}
        />
      </Row>
    </>
  );
};

export default injectTranslations(Basket);
